<template>
  <metainfo>
    <template v-slot:title="{ content }">{{ content }} - Mouvi</template>
  </metainfo>
  <div class="container mx-auto text-center pt-20">
    <h1 class="text-white font-semibold text-lg sm:text-xl">
      404: The page you are looking for isn’t here
    </h1>
    <p class="text-gray-500 text-base sm:text-lg">
      You either tried some shady route or you came here by mistake. Whichever
      it is, try using the navigation.
    </p>
    <div class="flex items-center justify-center mt-4 w-8/12 xl:w-4/12 mx-auto">
      <img
        alt="Not Found"
        className="w-full h-full"
        src="@/assets/images/404.svg"
      />
    </div>
  </div>
</template>
